import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useState, useRef, useEffect } from "react";
import { checkWindow } from "@vfit/shared/data-access";
import { LoggerInstance } from "@vfit/shared/providers";
import { colors } from "@vfit/shared/themes";
import Story from "../Story/Story";
import ProgressArray from "../ProgressArray/ProgressArray";
import GlobalContext from "../../context/Global";
import StoriesContext from "../../context/Stories";
import ProgressContext from "../../context/Progress";
import useIsMounted from "../../hooks/useIsMounted";
import { ContainerStyled } from "./Container.style";
var Container = function() {
    var ref = useState(0), currentId = ref[0], setCurrentId = ref[1];
    var ref1 = useState(true), pause = ref1[0], setPause = ref1[1];
    var ref2 = useState(true), bufferAction = ref2[0], setBufferAction = ref2[1];
    var ref3 = useState(0), videoDuration = ref3[0], setVideoDuration = ref3[1];
    var isMounted = useIsMounted();
    var mousedownId = useRef();
    var ref4 = useContext(GlobalContext), width = ref4.width, height = ref4.height, loop = ref4.loop, currentIndex = ref4.currentIndex, isPaused = ref4.isPaused, keyboardNavigation = ref4.keyboardNavigation, preventDefault = ref4.preventDefault, _storyContainerStyles = ref4.storyContainerStyles, storyContainerStyles = _storyContainerStyles === void 0 ? {} : _storyContainerStyles, onAllStoriesEnd = ref4.onAllStoriesEnd, onPrevious = ref4.onPrevious, onNext = ref4.onNext;
    var stories = useContext(StoriesContext).stories;
    useEffect(function() {
        if (typeof currentIndex === "number") {
            if (currentIndex >= 0 && currentIndex < stories.length) {
                setCurrentIdWrapper(function() {
                    return currentIndex;
                });
            } else {
                LoggerInstance.error("Index out of bounds. Current index was set to value more than the length of stories array.", currentIndex);
            }
        }
    }, [
        currentIndex
    ]);
    useEffect(function() {
        if (typeof isPaused === "boolean") {
            setPause(isPaused);
        }
    }, [
        isPaused
    ]);
    useEffect(function() {
        if (checkWindow() && typeof keyboardNavigation === "boolean" && keyboardNavigation) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        keyboardNavigation
    ]);
    var handleKeyDown = function(e) {
        if (e.key === "ArrowLeft") {
            previous();
        } else if (e.key === "ArrowRight") {
            next({
                isSkippedByUser: true
            });
        }
    };
    var toggleState = function(action, bufferActionLocal) {
        setPause(action === "pause");
        setBufferAction(!!bufferActionLocal);
    };
    var setCurrentIdWrapper = function(callback) {
        setCurrentId(callback);
        toggleState("pause", true);
    };
    var previous = function() {
        if (onPrevious != undefined) {
            onPrevious();
        }
        setCurrentIdWrapper(function(prev) {
            return prev > 0 ? prev - 1 : prev;
        });
    };
    var next = function(options) {
        if (onNext != undefined && (options === null || options === void 0 ? void 0 : options.isSkippedByUser)) {
            onNext();
        }
        if (isMounted()) {
            if (loop) {
                updateNextStoryIdForLoop();
            } else {
                updateNextStoryId();
            }
        }
    };
    var updateNextStoryIdForLoop = function() {
        setCurrentIdWrapper(function(prev) {
            if (prev >= stories.length - 1) {
                onAllStoriesEnd === null || onAllStoriesEnd === void 0 ? void 0 : onAllStoriesEnd(currentId, stories);
            }
            return (prev + 1) % stories.length;
        });
    };
    var updateNextStoryId = function() {
        setCurrentIdWrapper(function(prev) {
            if (prev < stories.length - 1) return prev + 1;
            onAllStoriesEnd === null || onAllStoriesEnd === void 0 ? void 0 : onAllStoriesEnd(currentId, stories);
            return prev;
        });
    };
    var debouncePause = function(e) {
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mousedownId.current = setTimeout(function() {
            toggleState("pause");
        }, 200);
    };
    var mouseUp = function(type) {
        return function(e) {
            e.preventDefault();
            mousedownId.current && clearTimeout(mousedownId.current);
            if (pause) {
                toggleState("play");
            } else {
                type === "next" ? next({
                    isSkippedByUser: true
                }) : previous();
            }
        };
    };
    var getVideoDuration = function(duration) {
        setVideoDuration(duration * 1000);
    };
    return /*#__PURE__*/ _jsxs(ContainerStyled, {
        style: _object_spread({}, styles.container, storyContainerStyles, {
            width: width,
            height: height
        }),
        children: [
            /*#__PURE__*/ _jsx(ProgressContext.Provider, {
                /* eslint-disable-next-line react/jsx-no-constructed-context-values */ value: {
                    bufferAction: bufferAction,
                    videoDuration: videoDuration,
                    currentId: currentId,
                    pause: pause,
                    next: next
                },
                children: /*#__PURE__*/ _jsx(ProgressArray, {})
            }),
            /*#__PURE__*/ _jsx(Story, {
                action: toggleState,
                bufferAction: bufferAction,
                playState: pause,
                story: stories[currentId],
                getVideoDuration: getVideoDuration
            }),
            !preventDefault && /*#__PURE__*/ _jsxs("div", {
                className: "overlay",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: "50%",
                            zIndex: 999,
                            cursor: "pointer"
                        },
                        onTouchStart: debouncePause,
                        onTouchEnd: mouseUp("previous"),
                        onMouseDown: debouncePause,
                        onMouseUp: mouseUp("previous")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: "50%",
                            zIndex: 999,
                            cursor: "pointer"
                        },
                        onTouchStart: debouncePause,
                        onTouchEnd: mouseUp("next"),
                        onMouseDown: debouncePause,
                        onMouseUp: mouseUp("next")
                    })
                ]
            })
        ]
    });
};
var styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        background: colors.$0d0d0d,
        position: "relative",
        WebkitUserSelect: "none"
    }
};
export default Container;
